(() => {
  'use strict';
  if (customElements.get('db-card-badges')) return;
  const script = document.currentScript;
  const logosUrl = script.dataset.logos;
  const assetBase = script.dataset.assetBase;
  let logosPromise;
  customElements.define('db-card-badges', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      if (this.dataset.sale === 'true') {
        const sale = document.createElement('span'); sale.className = 'db-card-sale';
        sale.textContent = this.dataset.saleLabel; this.append(sale);
      }
      if (!this.dataset.brand) return;
      const brand = this.dataset.brand;
      const mark = document.createElement('span'); mark.className = 'db-card-logo';
      mark.textContent = brand; this.append(mark);
      logosPromise ||= fetch(logosUrl, { signal: AbortSignal.timeout(8000) }).then(r => {
        if (!r.ok) throw new Error('Brand marks unavailable'); return r.json();
      }).catch(() => ({}));
      logosPromise.then(logos => {
        if (!this.isConnected) return;
        const logo = logos[brand.trim().toLowerCase()];
        if (!logo) return;
        const image = document.createElement('img');
        image.className = 'db-card-brand-image'; image.alt = brand;
        image.src = logo.url || assetBase + logo.file + (logo.version ? `?v=${encodeURIComponent(logo.version)}` : '');
        image.width = 72; image.height = 30; image.loading = 'lazy'; image.decoding = 'async';
        image.style.setProperty('--brand-zoom', logo.zoom || 1);
        if (logo.invert) image.classList.add('db-brand-invert');
        image.addEventListener('error', () => { mark.textContent = brand; }, { once: true });
        mark.replaceChildren(image);
      });
    }
  });
})();
